import { makeStyles } from '@material-ui/core';

export const useSnippetCardStyles = makeStyles(() => ({
  container: { display: 'flex', flexDirection: 'column', alignItems: 'start' }
}));
